const generalMethods = {
  GlobalConfig: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'general/GlobalConfig',
    httpMethod: 'get',
    isJsonRequest: true,
    withCredentials: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  headerSearch: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Search',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['SearchQuery', 'StartIndex', 'ItemCount'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getTvCatalogItems: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'TvContent',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['id', 'notViewIds', 'pageSize', 'pageIndex'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetSubscriberForRge: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvContent/GetSubscriberForRge',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createOtp: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/Step1',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['PhoneNumber', 'SendTextAsVoice', 'captchaToken', 'appName', 'OtpOrigin', 'OriginProcess'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  validateOtp: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/Step2',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['PhoneNumber', 'TicketId', 'CodeEntered', 'appName', 'OtpOrigin, OriginProcess'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  LoginStep1: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/LoginStep1',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    withCredentials: true,
    getArgumentName: ['Subscriber', 'ProcessType', 'OtpOrigin', 'OriginProcess' , 'LoginType', 'GenericFields'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },


  LoginStep1Full: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/LoginStep1Full',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    withCredentials: true,
    getArgumentName: ['Subscriber', 'IdNumber', 'Digits', 'OriginProcess', 'CustomerEmail', 'LoginType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  ResendLoginStep1: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/ResendLoginStep1',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    withCredentials: true,
    getArgumentName: ['Subscriber', 'IsSms', 'ValidationToken'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  ChangeContactNumberLogin: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/ChangeContactLogin',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    withCredentials: true,
    getArgumentName: [
      'Subscriber',
      'OtpCode',
      'Guid',
      'RestrictCode',
      'IdNumber',
      'ConsumerIds',
      'PaymentDigits',
      'ChangeContact',
      'MainContactCli',
      'ContactId',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  LoginStep2: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'otp/LoginStep2',
    httpMethod: 'put',
    isJsonRequest: true,
    withCredentials: true,
    enableRecaptcha: true,
    getArgumentName: ['Guid', 'OtpCode', 'Subscriber', 'RestrictCode', 'TermsAccepted', 'CheckPhoneNumber', 'LoginType', 'GenericFields'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  OtpExtendedStep1: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'otp/OtpExtendedStep1',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['Subscriber', 'IsExtended', 'OtpOrigin', 'OriginProcess'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  OtpExtendedStep2: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'otp/OtpExtendedStep2',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [
      'subscriber',
      'otpCode',
      'guid',
      'restrictCode',
      'termsAccepted',
      'checkPhoneNumber',
      'loginType',
      'OtpOrigin',
      'OriginProcess',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  LoginStep3: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'otp/LoginStep3',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    withCredentials: true,
    getArgumentName: ['Subscriber', 'IdNumber', 'Scope', 'Code', 'OtpOrigin', 'OriginProcess'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  RefreshToken: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'otp/RefreshToken',
    httpMethod: 'put',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['RefreshToken'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  uploadFileForValidation: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'General/UploadFile',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['FileType', 'FileContentBase64', 'capchaValue', 'ConsumerId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  openWorkOrder: {
    //77
    online: true,
    requiredLogin: false,
    apiSuffixName: 'WorkOrder/CreateAmdocsWorkOrder',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  openWorkOrderVolte: {
    //77
    online: true,
    requiredLogin: false,
    apiSuffixName: 'WorkOrder/CreateWorkOrderVolte',
    enableRecaptcha: true,
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createWorkOrder: {
    // 77 or 1712
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'WorkOrder/CreateWorkOrder',
      },
      AUTHENTICATED: {
        apiSuffixName: 'WorkOrder/CreateWorkOrderAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  initiateRouterActivationWizard: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/Initiate',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['equipmentid'],
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getRouterActivationWizardStep: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/GetWizardStep',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['requestId'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getFiberMigrationWizardStep: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/GetFiberMigrationWizardStep',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  setRouterActivationWizardStep: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/SetWizardStep',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCGEMVStep1: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Payment/emvStep1',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['type', 'id', 'totalPrice', 'numberOfPayments', 'midType', 'isIDF', 'source'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCGEMVStep2: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Payment/emvStep2',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['Total', 'Token', 'Type', 'IsShowIdNumber', 'Id', 'BlockId', 'MidType', 'isIDF', 'Source'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSitesLocation: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'general/GetSitesLocation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getTransactionSummaryData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'TransactionSummary/GetTransactionSummaryData',
    enableRecaptcha: true,
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['guidId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getLawClassActionResult: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'General/GetLawClassActionResult',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['captchaToken', 'IdNumber', 'Phone', 'SearchType', 'LawClassActionCode'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getServiceCenteresNearBy: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'general/GetServiceCenteresNearBy',
    httpMethod: 'get',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: ['city'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCitiesByValue: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'general/GetCities',
    httpMethod: 'get',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: ['value'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getProducts: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MovingApartment/GetProducts',
    httpMethod: 'get',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  moveApartment: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MovingApartment/MovingApartmentExecution',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createMovingSale: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MovingApartment/CreateMovingSale',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  creditCardValidation: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CreditCard/Validation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['creditCardType', 'creditCardNumber', 'idNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  UnsubscribeMail: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'General/UnsubscribeMail',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['email'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  UnsubscribeSms: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'General/UnsubscribeSms',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetPriceAndTechnicianType: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MovingApartment/GetPriceAndTechnicianType',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getClientLocationData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'ClientLocation/GetClientLocation',
    httpMethod: 'get',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: ['GUID'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  postClientLocationData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'ClientLocation/PostClientLocation',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: ['GUID', 'X', 'Y'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  bezeqCheckTechnicianType: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/BezeqCheckTechnicianType',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: true,
    getArgumentName: ['iipSeq'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getWarrantyStatus: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'WarrantyStatus/GetWarrantyStatus',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['serialNumber', 'actionMode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  movingApartmentCheckPinTechnician: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'PinTechnician/MovingApartmentPinTechnician',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  movingApartmentPinTechnicianAfterSlot: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'PinTechnician/MovingApartmentPinTechnicanAfterSlot',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  movingApartmentAddressUpdate: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MovingApartment/AddressUpdate',
    httpMethod: 'post',
    enableRecaptcha: true,
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  movingApartmentWhatsAppActivity: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'WhatsApp/MovingApartmentWhatsAppActivity',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  movingApartmentOpenWhatsApp: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'WhatsApp/MovingApartmentOpenWhatsApp',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSaleWhatsAppActivity: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Whatsapp/GetSaleWhatsAppActivity',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSelfCareWhatsAppActivity: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Whatsapp/GetSelfCareWhatsAppActivity',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getEsimWhatsAppActivity: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Whatsapp/GetEsimWhatsAppActivity',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  selfCareOpenWhatsApp: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'WhatsApp/SelfCareOpenWhatsApp',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  esimOpenWhatsApp: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'WhatsApp/EsimOpenWhatsApp',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAddressEntries: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Address/GetAddressEntries',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['cityCode', 'streetCode', 'houseNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSubscribers: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Subscribers/GetSubscribers',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['saleType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAddressDetails: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Address/GetAddressDetails',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createMemo: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Memo/CreateMemo',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createMemoMoving: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Memo/CreateMemoMoving',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createMemoIntCr: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Memo/CreateMemoIntCr',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  PostEcommerceRegistrationCompletion: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ecommerce/connectTokenToSession',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['Scope', 'ClientId', 'ClientSecret', 'LoginType', 'Sid', 'SubscriberNumber', 'Hash'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  GetCustomerSplitSubscriptionNumberList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ProductsAndServices/GetCustomerSplitSubscriptionNumberList',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  IsCellcomNumber: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'NumberValidation/IsCellcomNumber',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  IsExternalCompanyNumber: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'NumberValidation/IsExternalCompanyNumber',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['phoneNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getBanksList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Payment/GetBanksList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getBankBranchesList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Payment/GetBankBranchesList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['bankCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  sendResume: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'careers/job',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['jobId', 'firstName', 'lastName', 'email', 'phone', 'fileName', 'fileType', 'FileStream', 'city', 'source', 'sender'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  getCustomerDetails: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CustomerDetails/GetCustomerDetails',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  generalPurposeMagicLink: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/GeneralPurposeMagicLink',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['clientName', 'scopeName', 'isDynamic', 'sendSms', 'sendEmail', 'parameters'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  onlyMobileML: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/SendPhoneForMl',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'banNumberList'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  UploadFileToJet: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/UploadFileToJet',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['phoneNumber', 'ban', 'fileStream', 'fileName', 'consumerId', 'accountId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  IsIdNumberValid: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/CheckIdNumber',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['idNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  IsExceedingPayingEntityMax: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Payment/IsExceedingPayingEntityMax',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['idNumber', 'idType', 'marketCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  occasionalCreditCardInputBlackListValidation: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'CreditCard/OccasionalCreditCardInputBlackListValidation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['creditCardType', 'creditCardNumber', 'idNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  jetUpdateOpportunityCreditCard: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'CreditCard/JetUpdateOpportunityCreditCard',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'creditCardNumber',
      'expirationDate',
      'idNumber',
      'creditCardType',
      'terminalNumber',
      'authNumber',
      'cardBrand',
      'creditCompany',
      'pymBlackList',
      'capacityOverflow',
      'delinquentCustomers',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  closingMagicLink: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MagicLink/ClosingMagicLink',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['clientName', 'scopeName'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  IECBotCheckSmartMeter: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'IEC/IECBotCheckSmartMeter',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetDeliverySlotsByAdress: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/GetDeliverySlotsByAdress',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['city', 'street', 'homeNum', 'isIDF'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getInternetProducts: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'zoneFault/GetInternetProducts',
    httpMethod: 'get',
    isJsonRequest: false,
    // enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getZoneFaultStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'zoneFault/GetZoneFaultStatus',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    // enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  zoneFaultSendNotificationToUser: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'zoneFault/SendNotificationToUser',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    // enableRecaptcha: true,
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkIsRecommendPowerSupply: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'internetAction/CheckIsRecommendPowerSupply',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  routerActivationWizardInitiate: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/RouterActivationWizardInitiate',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  routerActivationGetDelivery: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/RouterActivationGetDelivery',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  routerActivationCreateDeliveryOrder: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/RouterActivationCreateDeliveryOrder',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  routerActivationCreatePickUp: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/RouterActivationCreatePickUp',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  InitiateFiberMigrationWizard: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/FiberMigrationWizardInitiate',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  routerActivationWizardGetStep: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'RouterActivationWizard/RouterActivationWizardGetStep',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getWizardTechTimeslots: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/GetWizardTechTimeslots',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  setWizardTechTimeSlot: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/setWizardTechTimeSlot',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getIspConnectionDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'General/GetIspConnectionDetails',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  sendSms: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'General/SendSmsByoffline',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: ['contactPhoneNumber', 'textMessage'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  sendCouponsSms: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'General/SendCouponsSms',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: ['templateName', 'isVoiceSms', 'primaryContactPhone', 'couponType', 'voucherParamList'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSubscribersByProduct: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Subscribers/GetSubscribersByProduct',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: ['saleType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getSubscribersByProductType: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Ban/GetSubscribersByProductType',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: ['productType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  sendGuideFeedback: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'General/SendGuideFeedback',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getWizardScreens: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'GenericWizard/GetWizardScreens',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['wizardId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getWifiData: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'InternetAction/GetWiFiData',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  updateWifiSettings: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'InternetAction/UpdDvcWifiSettings',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getPinParentalCode: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/GetPinParentalCode',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkDeviceConnection: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'InternetAction/CheckDeviceConnection',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  restartDevice: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'InternetAction/RestartDevice',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getCustomerNvOrgList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessMonitoringCharts/GetCustomerNvOrgList',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAdminNvOrgList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'BusinessMonitoringCharts/GetAdminNvOrgList',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getChartList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessMonitoringCharts/GetChartList',
    httpMethod: 'post',
    isJsonRequest: true,
    postArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAdminChartList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'BusinessMonitoringCharts/GetAdminChartList',
    httpMethod: 'post',
    isJsonRequest: true,
    postArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getChartItem: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessMonitoringCharts/GetChartItem',
    httpMethod: 'post',
    isJsonRequest: true,
    postArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  getAdminChartItem: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'BusinessMonitoringCharts/GetAdminChartItem',
    httpMethod: 'post',
    isJsonRequest: true,
    postArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  updateServiceName: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'BusinessMonitoringCharts/UpdateServiceName',
    httpMethod: 'post',
    isJsonRequest: true,
    postArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetEcommerceOrganizationList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'OrganizationPortal/GetEcommerceOrganizationList',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  checkImeiStatus: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'IMEIStatus',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['imei'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  invokeAction: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'invokeActions/GetData',
    httpMethod: 'post',
    isJsonRequest: true,
    postArgumentName: ['action','method', 'sourceId', 'jsonString'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  }
};
export default generalMethods;
